export const defaultChartOptions = (theme) => {
    const fontFamily = 'CircularXXWeb';
    const axis = {
        ticks: {
            font: {
                size: 12,
                family: fontFamily,
                weight: '500',
                lineHeight: 1.33,
            },
            color: theme?.colors?.grey100_1,
        },
        border: {
            color: theme?.colors?.grey10_1,
            dash: [4, 4],
        },
        grid: {
            color: theme?.colors?.grey10_1,
            tickBorderDash: [4, 4],
        },
    };
    return {
        borderColor: theme?.colors?.grey00_1,
        responsive: true,
        layout: {
            padding: 0,
        },
        scales: {
            x: axis,
            y: {
                title: {
                    display: true,
                    font: {
                        size: 14,
                        family: fontFamily,
                        weight: '500',
                        lineHeight: 1.42,
                    },
                    color: theme?.colors?.black_1,
                    padding: {
                        bottom: 15,
                    },
                },
                ticks: axis.ticks,
                border: axis.border,
                grid: axis.grid,
            },
        },
        font: {
            family: fontFamily,
            size: 12,
            weight: '500',
        },
        interaction: {
            intersect: true,
            mode: 'point',
        },
        plugins: {
            tooltip: {
                cornerRadius: 8,
                displayColors: true,
                caretSize: 0,
                xAlign: 'center',
                yAlign: 'bottom',
                backgroundColor: theme?.colors?.black_1,
                titleColor: theme?.colors?.grey00_1,
                titleFont: {
                    family: fontFamily,
                    size: 12,
                    weight: '450',
                    lineHeight: 1.33,
                },
                titleAlign: 'center',
                titleMarginBottom: 16,
                bodyColor: theme?.colors?.grey00_1,
                bodyFont: {
                    family: fontFamily,
                    size: 12,
                    weight: '450',
                    lineHeight: 1.33,
                },
                bodyAlign: 'left',
                callbacks: {
                    label: (tooltipItem) => tooltipItem.formattedValue ?? tooltipItem,
                },
                padding: () => ({
                    top: 8,
                    bottom: 8,
                    right: 12,
                    left: 12,
                }),
            },
            legend: {
                display: false,
            },
            legendState: {
                display: false,
            },
            datalabels: {
                display: false,
            },
            corsair: {
                display: false,
                color: theme?.colors?.grey70_1,
            },
        },
    };
};
